<div class="information">
  <div class="information__header">
    <navigation-logo [mode]="'mobile'"></navigation-logo>

    <h1 class="information__title">{{ 'components.navigation.constants.navigationItems.infoTitle' | translate }}</h1>

    <div class="right-menu">
      <navigation-message [mode]="'mobile'"></navigation-message>

      <association-menu *ngIf="associationMenuVisible" [mode]="'mobile'"></association-menu>
    </div>
  </div>

  <tui-scrollbar class="information__list">
    <app-navigation-list [navTree]="navTree" [additionalNavItems]="pagesNavItems$ | async"></app-navigation-list>
  </tui-scrollbar>
</div>
